import React from 'react';
import { fetchCompanies } from '../../../actions/companies/apiRequests';
import AsyncDropdown from '../AsyncDropdown';


const CompanyDropdown = (props) => (
  <AsyncDropdown
    placeholder={'Select Company'}
    fetchOptions={fetchCompanies}
    getLabel={option => `${option.name} - ${option.customerNumber}`}
    {...props}
  />
);

export default CompanyDropdown;


// WEBPACK FOOTER //
// src/components/shared/CompanyDropdown/index.jsx